<template>
  <div>
    <ArticleHeader :img_header="header_image" header="เพิ่มบทความใหม่" link_back="articlemanage"/>
    <Article_add/>
  </div>
</template>

<script>
import ArticleHeader from "@/components/admin/manage_website/article_setting/menu_article/ArticleHeader";
import HeaderImage from "@/assets/copywriting.png";
import Article_add from "@/components/admin/manage_website/article_setting/Article_add";
export default {
  name: "ArticleAdd",
  components: {
    Article_add,
    ArticleHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
